import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'
import { IProfile, IProfilesState } from 'interfaces/profiles'

const initialState: IProfilesState = {
  items: [],
  loading: false,
  loaded: false,
}

const profilesSlice = createSlice({
  name: 'profiles',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setItems: (state, action: PayloadAction<IProfile[]>) => {
      state.items = action.payload
      state.loaded = true
    },
  },
})

const { setLoading, setItems } = profilesSlice.actions
const loading = (state: RootState) => state.profiles.loading
const loaded = (state: RootState) => state.profiles.loaded
const items = (state: RootState) => state.profiles.items

export const profiles = { setLoading, setItems, loading, loaded, items }

export default profilesSlice.reducer
